import React from 'react';
import ActionButton from '../../../declarants/groupButton';
import {DeclarantId} from "../../../../models/Declarant";
import AbstractDeclarantStore from "../../../../stores/AbstractDeclarantStore";
import {SyncOutlined} from "@ant-design/icons";
import Authorize from "../../../Authorize";
import {UPLOAD_XML} from "../../../../constants/authorize";

type SingleTwsSyncActionProps = {
  store: AbstractDeclarantStore;
  id: DeclarantId;
  disabled?: boolean;
};

const SingleTwsSyncAction = ({ store, id, disabled = false }: SingleTwsSyncActionProps) => {
  return (
    <ActionButton
      disabled={disabled}
      onClick={async () => {
        await store.singleTwsSync(id);
        store.load({}, true);
      }}
      tooltip
      tooltipProps={{
        title: disabled ? 'TWS Sync is unavailable for exposed records' : 'TWS Sync',
        placement: 'top',
      }}
      loadingOnProcess
      content={<SyncOutlined />}
    />
  );
};

export default SingleTwsSyncAction;